export enum EVideoInfoParseStatus {
  parsing = "parsing",
  end = "end",
  error = "error",
}

export interface IVideoClipInfo {
  "start": number;
  "end": number;
  "index"?: number;
  "title": string;
  "other": string;
  "description": string;
  "reason": string;
  "commentary": string;
}

export enum EVideoUploadStatus {
  BEFORE_UPLOAD = 1,
  UPLOADING = 2,
  UPLOADED = 3,
  UPLOAD_FAILED = 4,
}

export interface IVideoFileInfo {
  url: string; // 视频URL
  fileId: string; // 文件ID
}

export interface IVideoMetaData {
  videoHeight?: number;
  videoWidth?: number;
  duration?: number;
}

export interface IVideoFileUploadInfo extends IVideoFileInfo {
  uploadStatus: EVideoUploadStatus;
  file?: File;
  metaData?: IVideoMetaData;
  duration?: number;
  thumbnail?: File;
  thumbnailUrl?: string;
}

export interface IUploadCheckResult {
  durationInvalid?: boolean;
  durationError?: boolean;
  resolutionInvalid?: boolean;
}
